module.exports = __webpack_public_path__ + "fontawesome-webfont.woff2?af7ae505a9eed503f8b8e6982036873e";